module.exports = __webpack_public_path__ + "static/media/clipLogo.209236cf.png";